import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { formatAmount } from 'src/utils/formatAmout';

const DiscountGridRow = ({
  initialPayment,
  discountTwelve,
  discountEighteen,
  discountTwentyFour,
  discountThirtySix
}) => {
  return (
    <TableRow hover>
      <TableCell>{`${initialPayment}%`}</TableCell>
      <TableCell align="center">{`${formatAmount(discountTwelve)}%`}</TableCell>
      <TableCell align="center">
        {`${formatAmount(discountEighteen)}%`}
      </TableCell>
      <TableCell align="center">
        {`${formatAmount(discountTwentyFour)}%`}
      </TableCell>
      <TableCell align="center">
        {`${formatAmount(discountThirtySix)}%`}
      </TableCell>
    </TableRow>
  );
};

DiscountGridRow.propTypes = {
  initialPayment: PropTypes.number.isRequired,
  discountTwelve: PropTypes.number.isRequired,
  discountEighteen: PropTypes.number.isRequired,
  discountTwentyFour: PropTypes.number.isRequired,
  discountThirtySix: PropTypes.number.isRequired
};

export default DiscountGridRow;
